import * as PropTypes from 'prop-types';
import * as React from 'react';
import AddToCartButton from './add_to_cart_button';
import Upsells from '../../product_show_page/upsells';

const ModalUpsells = props => (
  <Upsells
    listingId={props.listingId}
    children={props.children}
    aid="related_content_upsells_modal"
    addToCartButton={AddToCartButton}
  />
);

ModalUpsells.propTypes = {
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ModalUpsells;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/modal_upsells.jsx